<template>
  <div
    v-if="gosterilsinMi"
    class="mb-3 sm:mb-4 flex items-center gap-3 p-3 rounded-lg border-l-4"
    :class="basicMi
      ? 'zemin-olumsuz kenar-olumsuz'
      : 'zemin-uyari kenar-uyari'"
  >
    <i
      :class="basicMi ? 'pi pi-exclamation-triangle renk-olumsuz' : 'pi pi-clock renk-uyari'"
      class="text-xl shrink-0"
    ></i>
    <span
      class="flex-1 text-sm font-semibold"
      :class="basicMi ? 'renk-olumsuz' : 'renk-uyari'"
    >
      <span class="hidden sm:inline">{{ mesajUzun }}</span>
      <span class="sm:hidden">{{ mesajKisa }}</span>
    </span>
    <Button
      label="Yenile"
      icon="pi pi-refresh"
      :severity="basicMi ? 'danger' : 'warn'"
      class="hidden sm:inline-flex"
      @click="yenile"
    />
    <Button
      icon="pi pi-refresh"
      :severity="basicMi ? 'danger' : 'warn'"
      class="sm:hidden"
      aria-label="Yenile"
      @click="yenile"
    />
    <Button
      icon="pi pi-times"
      text
      :severity="basicMi ? 'danger' : 'warn'"
      aria-label="Kapat"
      @click="kapat"
    />
  </div>
</template>

<script>
import { uiState } from "@/services/uiState";

const KAPAT_ANAHTARI = "lisansUyariKapat";

// LS4: Basic (TemelMi) kırmızı + "hesabınıza erişim kapanır" ağırlıklı metin, modül lisansı sarı.
// Kapatma gün bazlı (sessionStorage) - gün değişince tekrar çıkar, plan LISANS-SISTEMI-PLANI.md.
export default {
  name: "LisansUyariSeridi",
  data() {
    return {
      kapatildi: sessionStorage.getItem(KAPAT_ANAHTARI) === new Date().toDateString(),
    };
  },
  computed: {
    uyari() {
      return uiState.lisansUyari;
    },
    gosterilsinMi() {
      return !!this.uyari && !this.kapatildi;
    },
    basicMi() {
      return !!this.uyari?.TemelMi;
    },
    gunMetni() {
      return this.uyari.KalanGun <= 0 ? "bugün" : this.uyari.KalanGun + " gün sonra";
    },
    mesajUzun() {
      if (!this.uyari) return "";
      return this.basicMi
        ? `Basic paketinizin süresi ${this.gunMetni} doluyor. Yenilenmezse hesabınıza erişim kapanır; verileriniz silinmez.`
        : `${this.uyari.Ad} modülünüzün süresi ${this.gunMetni} doluyor.`;
    },
    mesajKisa() {
      if (!this.uyari) return "";
      const gun = this.uyari.KalanGun <= 0 ? "bugün bitiyor" : this.uyari.KalanGun + " gün sonra bitiyor";
      return this.basicMi ? `Basic ${gun}` : `${this.uyari.Ad} ${gun}`;
    },
  },
  // YNL2: tek methods bloğu — iki blok olunca sonraki öncekini siliyordu (yenile tanımsız kalıyordu).
  methods: {
    // YNL1-2: hangi lisansın süresi doluyorsa Satın Al o paket seçili açılır.
    yenile() {
      const kod = this.uyari && this.uyari.Kod ? String(this.uyari.Kod).toLowerCase() : "";
      this.$router.push(kod ? { path: "/lisans/satinal", query: { uzat: kod } } : "/lisans/satinal");
    },
    kapat() {
      sessionStorage.setItem(KAPAT_ANAHTARI, new Date().toDateString());
      this.kapatildi = true;
    },
  },
};
</script>
